import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MyAccountNavComponent } from '../my-account-nav/my-account-nav.component';

/**
 * Contextual left sidebar for the "Mein Konto" area. Rendered only while the
 * active route belongs to that section (see `BreadcrumbService.section`); the
 * links and their access rules live in {@link MyAccountNavComponent}.
 */
@Component({
  imports: [RouterModule, MyAccountNavComponent],
  selector: 'app-shop-nav',
  templateUrl: './shop-nav.component.html',
  styleUrls: ['./shop-nav.component.css'],
})
export class ShopNavComponent {}
